<template>
	<Dialog
		max-width="600"
		content-height="50"
		title="Add a new article"
		:show="show"
		@close="close"
	>
		<template slot="content">
			<v-autocomplete
				v-model="article.projectId"
				:error-messages="article.errors.projectId"
				:disabled="reports.loading"
				:items="projects.models"
				no-data-text="No projects found. Please create a new project"
				label="Project"
				item-text="name"
				item-value="id"
			/>
			<v-autocomplete
				v-model="article.reportId"
				:error-messages="article.errors.reportId"
				:loading="reports.loading"
				:disabled="reports.loading || !article.projectId"
				:items="reports.models"
				no-data-text="No reports found"
				label="Report"
				item-text="displayName"
				item-value="id"
			/>
		</template>
		<template slot="buttons">
			<v-btn
				flat
				color="success"
				:disabled="disabledButtons"
				@click="redirectToCreate()"
			>
				Continue
			</v-btn>
		</template>
	</Dialog>
</template>

<script>
import Dialog from '@/components/Global/Dialog';
import { Article } from '@/models/Article';
import { Reports } from '@/models/Report';

export default {
	components: {
		Dialog,
	},
	data() {
		return {
			show: false,
			article: new Article(),
			reports: new Reports(),
		}
	},
	computed: {
		projects() {
			return this.$store.get('projects/active');
		},
		disabledButtons() {
			return this.article.projectId === null || this.article.reportId === null;
		},
	},
	watch: {
		'article.projectId'(projectId) {
			this.reports.set('id', projectId);
			this.reports.fetch().then().catch((e) => {
				dump('Error fetching reports for project', e);
				this.article.setErrors({
					reportId: 'Failed to load reports for selected project',
				});
			});
		},
	},
	methods: {
		redirectToCreate() {
			this.close();
			this.$store.set('articlesNew/showAddArticlesForm', true);
			this.$router.push({ name: 'ArticlesList', params: { reportId: this.article.reportId } });
		},
		close() {
			this.show = false;
		},
	},
}
</script>
